import connectfour from "../../images/connectfour.png";
import casette from "../../images/casette.gif";
import ballcatcher from "../../images/ballcatcher.png";
import xylophone from "../../images/xylophone.png";
import croc from "../../images/croc.gif";
import childhood from "../../images/childhood-full.png";

export default function Nostalgia() {
  return (
    <div>
      <div className="header">
        <h1>Childhood Nostalgia</h1>
        <p>
          This is a personal project that revisits my favorite childhood toys in
          3D. I worked on this for two weeks in September 2022. I worked with
          Redshift renderer, which was such a joy for realistic lighting!
        </p>
        <div className="two-column-img">
          <img className="medium-img" src={connectfour} />
          <img className="medium-img" src={casette} />
        </div>
        <div className="two-column-img">
          <img className="medium-img" src={xylophone} />
          <img className="medium-img" src={croc} />
        </div>
        <div className="two-column-img">
          <img className="medium-img" src={ballcatcher} />
          <img className="medium-img" src={childhood} />
        </div>
      </div>
    </div>
  );
}
